export const AUTH_TOKEN_KEY = 'access_token';
export const MANAGING_PROFILE_ID_KEY = 'managing_profile_id';
export const REFRESH_TOKEN_KEY = 'refresh_token';
